import axios from "axios";
import { API_ENDPOINTS } from "../config/api";

const ARTICLE_ENGAGEMENT_ENDPOINT = API_ENDPOINTS.articleEngagement;
const ARTICLE_ENGAGEMENT_ANALYTICS_ENDPOINT = API_ENDPOINTS.articleEngagementAnalytics;

const buildArticleEngagementUrl = (slug, suffix = "") =>
  `${ARTICLE_ENGAGEMENT_ENDPOINT}/${encodeURIComponent(slug)}${suffix}`;

const buildInvalidResponseError = () =>
  new Error(
    "Article engagement API returned an unexpected response. Check the article engagement endpoint configuration."
  );

const assertObjectResponse = (data) => {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    throw buildInvalidResponseError();
  }

  return data;
};

const assertArticleEngagementPayload = (data) => {
  const payload = assertObjectResponse(data);

  if (
    typeof payload.likes !== "number" ||
    typeof payload.shares !== "number" ||
    !Array.isArray(payload.comments)
  ) {
    throw buildInvalidResponseError();
  }

  return payload;
};

const assertArticleEngagementAnalyticsPayload = (data) => {
  const payload = assertObjectResponse(data);

  if (
    !payload.summary ||
    typeof payload.summary !== "object" ||
    !Array.isArray(payload.topArticles) ||
    !Array.isArray(payload.recentComments)
  ) {
    throw buildInvalidResponseError();
  }

  return payload;
};

export const fetchArticleEngagement = async (slug, visitorId) => {
  const response = await axios.get(buildArticleEngagementUrl(slug), {
    params: visitorId ? { visitorId } : undefined,
  });
  return assertArticleEngagementPayload(response.data);
};

export const postArticleLike = async (slug, articleTitle, visitorId) => {
  const response = await axios.post(buildArticleEngagementUrl(slug, "/like"), {
    articleTitle,
    visitorId,
  });
  return assertArticleEngagementPayload(response.data);
};

export const postArticleComment = async (slug, payload) => {
  const response = await axios.post(
    buildArticleEngagementUrl(slug, "/comments"),
    payload
  );
  return assertArticleEngagementPayload(response.data);
};

export const postArticleShare = async (slug, payload) => {
  const response = await axios.post(
    buildArticleEngagementUrl(slug, "/share"),
    payload
  );
  return assertArticleEngagementPayload(response.data);
};

export const fetchArticleEngagementAnalytics = async (token) => {
  const response = await axios.get(ARTICLE_ENGAGEMENT_ANALYTICS_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return assertArticleEngagementAnalyticsPayload(response.data);
};
